import { Box } from "@mui/material";
import type React from "react";

export default function ChevronDivider() {
  return (
    <Box
      component="span"
      sx={{
        color: "text.disabled",
        fontSize: 20,
        userSelect: "none",
        flexShrink: 0,
      }}
    >
      ›
    </Box>
  );
}
